import {
  FlightLogsEvent,
  EventSubtype,
  EventType
} from '../../common/api/spidertracks-sdk/types/FlightLogs';

export const getTotalAirTimeMillis = (events: FlightLogsEvent[]) => {
  let airTime = 0;
  let prevEvent: {
    eventTime: number;
    eventSubtype: string;
  } | null = null;

  const takeoffOrLandingEvents = events.filter(
    event =>
      event.eventSubtype === EventSubtype.Takeoff || event.eventSubtype === EventSubtype.Landing
  );

  takeoffOrLandingEvents.sort((a, b) => {
    if (a.eventTime !== b.eventTime) {
      return a.eventTime - b.eventTime;
    }
    return a.eventSubtype === EventSubtype.Takeoff ? -1 : 1;
  });

  for (const event of takeoffOrLandingEvents) {
    if (
      prevEvent &&
      prevEvent.eventSubtype === EventSubtype.Takeoff &&
      event.eventSubtype === EventSubtype.Landing
    ) {
      airTime += event.eventTime - prevEvent.eventTime;
    }

    prevEvent = {
      eventTime: event.eventTime,
      eventSubtype: event.eventSubtype
    };
  }

  return airTime;
};
export const getPowerTimeMillis = (events: FlightLogsEvent[]) => {
  const powerOnEvents = events.filter(
    event => event.eventType === EventType.POWER && event.eventSubtype === EventSubtype.On
  );
  const powerOffEvents = events.filter(
    event => event.eventType === EventType.POWER && event.eventSubtype === EventSubtype.Off
  );

  if (powerOnEvents.length === 0 || powerOffEvents.length === 0) {
    return 0;
  }

  return powerOffEvents[powerOffEvents.length - 1].eventTime - powerOnEvents[0].eventTime;
};
export const getTotalBlocksOnTimeMillis = (events: FlightLogsEvent[]) => {
  const blocksEvent = events
    .filter(
      event =>
        (event.eventType === EventType.FLIGHT && event.eventSubtype === EventSubtype.BlocksOn) ||
        (event.eventType === EventType.FLIGHT && event.eventSubtype === EventSubtype.BlocksOff)
    )
    .sort((a, b) => {
      if (a.eventTime !== b.eventTime) {
        return a.eventTime - b.eventTime;
      }
      return a.eventSubtype === EventSubtype.BlocksOff ? -1 : 1;
    });

  let totalBlocksTime = 0;
  let prevEvent: {
    eventTime: number;
    eventSubtype: string;
  } | null = null;

  for (const event of blocksEvent) {
    if (
      prevEvent &&
      prevEvent.eventSubtype === EventSubtype.BlocksOff &&
      event.eventSubtype === EventSubtype.BlocksOn
    ) {
      totalBlocksTime += event.eventTime - prevEvent.eventTime;
    }

    prevEvent = {
      eventTime: event.eventTime,
      eventSubtype: event.eventSubtype
    };
  }

  return totalBlocksTime;
};
export const getTotalEngineTimeMillis = (events: FlightLogsEvent[]) => {
  const engineEvents = events.filter(event => {
    return (
      (event.eventType === EventType.ENGINE && event.eventSubtype === EventSubtype.On) ||
      (event.eventType === EventType.ENGINE && event.eventSubtype === EventSubtype.Off)
    );
  });

  engineEvents.sort((a, b) => {
    if (a.eventTime !== b.eventTime) {
      return Number(a.eventTime) - Number(b.eventTime);
    }
    // If the event times are the same, put engine on first
    return a.eventSubtype === EventSubtype.On ? -1 : 1;
  });

  let totalEngineTime = 0;
  let prevEvent: {
    eventTime: number;
    eventSubtype: string;
  } | null = null;

  for (const event of engineEvents) {
    if (
      prevEvent &&
      prevEvent.eventSubtype === EventSubtype.On &&
      event.eventSubtype === EventSubtype.Off
    ) {
      const engineTime = Number(event.eventTime) - Number(prevEvent.eventTime);
      totalEngineTime += engineTime;
    }

    prevEvent = {
      eventTime: event.eventTime,
      eventSubtype: event.eventSubtype
    };
  }

  return Math.round(totalEngineTime);
};
